import React from 'react';
import '../../styles/Button.css';

type ButtonProps = {
  label?: string;
  fontSize?: string;
  fontWeight?: number | string;
  lineHeight?: string;
  width?: string;
  height?: string;
  color?: string;
  backgroundColor?: string; // can be 'var(--primary)' or '#8b2cd7'
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const Button: React.FC<ButtonProps> = ({
  label = 'Log in',
  fontSize = '16px',
  fontWeight = 500,
  lineHeight = '20px',
  width = '352px',
  height = '56px',
  color = '#ffffff',
  backgroundColor = 'var(--primary)',
  disabled,
  onClick,
  style = {},
}) => {
  const combinedStyles: React.CSSProperties = {
    fontFamily: 'Montserrat',
    fontSize,
    fontWeight,
    lineHeight,
    color,
    backgroundColor,           // static bg; hover handled in CSS
    cursor: disabled ? 'not-allowed' : 'pointer',
    width,
    height,
    padding: '0 8px',
    border: 'none',
    borderRadius: '24px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'background-color .2s ease, transform .1s ease, filter .2s ease',
    ...style,
  };

  return (
    <button
      className="responsive-button"
      disabled={disabled}
      onClick={onClick}
      style={combinedStyles}
    >
      {label}
    </button>
  );
};

export default Button;
